export function removeDecimal(input: number | string) {
  // Convert input to a string
  let stringNumber = input.toString()
  // Find the index of the dot
  let dotIndex = stringNumber.indexOf('.')
  // If dot is found, return the substring before the dot, else return the original string
  return dotIndex !== -1 ? stringNumber.substring(0, dotIndex) : stringNumber
}
